import { Typography, Grid, Paper, TableContainer, Table, TableRow, TableCell, TableBody } from '@material-ui/core';

import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

import { makeStyles } from '@material-ui/core/styles';
import { convertUTCStringToLocalDateTime } from '../../../../../../utils/general/dateTime-utils';

const useStyles = makeStyles({
  chave: {
    display: 'flex',
    fontWeight: 'bold',
    fontSize: '1rem',
    wordWrap: 'break-word',
    whiteSpace: 'normal',
  },
  valor: {
    fontSize: '1rem',
    marginLeft: '0.5rem',
    fontWeight: 'normal',
    color: '#212121',
    wordWrap: 'break-word',
    whiteSpace: 'normal',
    flex: 1,
  },
  tableHeaderCell: {
    fontWeight: 'bold',
    color: '#212121',
  },
  tableCell: {
    borderBottom: '1px solid #e0e0e0',
  },
  mensagem: {
    wordWrap: 'break-word',
    whiteSpace: 'normal',
  },
  titulo: {
    fontSize: '1.rem',
    fontWeight: 'bold',
    color: 'secondary',
  },
  mensagemErro: {
    wordWrap: 'break-word',
    whiteSpace: 'normal',
    display: 'flex',
    gap: '9px',
    alignItems: 'center',
  },
});

export const RenderDadosLpcoTransmissao = ({ transmissao }: { transmissao: any }) => {
  const classes = useStyles();

  const exibeErro = transmissao?.jsonResposta?.field && transmissao?.jsonResposta?.message;
  const exibeDetalhes = transmissao?.jsonResposta?.detail;

  const dataTransmissao = transmissao?.dataTransmissao ? new Date(convertUTCStringToLocalDateTime(transmissao?.dataTransmissao)) : null;

  return (
    <Paper style={{ padding: '20px' }}>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <Typography variant="h6" color="primary" className={classes.chave}>
            Data envio:{' '}
            <span className={classes.valor}>
              {dataTransmissao && !Number.isNaN(dataTransmissao.getTime()) ? dataTransmissao.toLocaleString()  : ''}
            </span>
          </Typography>
        </Grid>

        {transmissao?.jsonResposta?.code && (
          <Grid item xs={6}>
            <Typography variant="h6" color="primary" className={classes.chave}>
              Codigo: <span className={classes.valor}>{transmissao?.jsonResposta?.code}</span>
            </Typography>
          </Grid>
        )}

        {transmissao?.statusTransmissao && (
          <Grid item xs={6}>
            <Typography variant="h6" color="primary" className={classes.chave}>
              Status: <span className={classes.valor}>{transmissao?.statusTransmissao}</span>
            </Typography>
          </Grid>
        )}

        {transmissao?.jsonResposta?.numero && (
          <Grid item xs={6}>
            <Typography variant="h6" color="primary" className={classes.chave}>
              N° Transmissão: <span className={classes.valor}>{transmissao?.jsonResposta?.numero}</span>
            </Typography>
          </Grid>
        )}

        {transmissao?.msgErro && (
          <Grid item xs={6}>
            <Typography variant="h6" color="primary" className={classes.chave}>
              Erro: <span className={classes.valor}>{transmissao?.msgErro}</span>
            </Typography>
          </Grid>
        )}

        <TableContainer>
          {(exibeErro || exibeDetalhes) && (
            <Typography
              color="secondary"
              variant="h6"
              className={classes.titulo}
              style={{ textAlign: 'center', margin: '1rem auto' }}
            >
              RELATORIO
            </Typography>
          )}

          <Table>
            <TableBody>
              {exibeErro && (
                <TableRow key={'a0'}>
                  <TableCell className={classes.mensagemErro}>
                    <span>
                      <ErrorOutlineIcon color="error" />
                    </span>
                    {`${transmissao?.jsonResposta?.field} - ${transmissao?.jsonResposta.message}`}
                  </TableCell>
                </TableRow>
              )}

              {exibeDetalhes &&
                transmissao?.jsonResposta?.detail.map((el: any, index: any) => (
                  <TableRow key={index}>
                    <TableCell className={classes.mensagemErro}>
                      <span>
                        <ErrorOutlineIcon color="error" />
                      </span>
                      {`${el.field ? el.field + '-' : ''} ${el.message}`}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Paper>
  );
};
